// extracted by mini-css-extract-plugin
export default {"hideTooltip":"G--z","fadeIn":"H--z","delay":"I--z","recommendedSizeTooltip":"J--z"};